import { gql, useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";
import { CurrencyContext } from "CurrencyProvider";
import { useContext } from "react";
import { computeCost } from "utils/cost";
import { CURRENCY_DICT } from "utils/invoice";

const FETCH_BOM = gql`
  query FETCH_BOM($ids: [ID]) {
    products(ids: $ids) {
      results {
        id
        suppliers {
          id
          company
          supplier {
            id
          }
        }
        activePrices {
          id
          company
          price
          archivedAt
          minQty
          currency
          factory {
            id
          }
        }
      }
    }
  }
`;

const CostPreview = ({ itemsPerSet, bom, qty, currency, company }) => {
  const { usdExchangeRates } = useContext(CurrencyContext);
  const ids = bom.map((i) => i.product.id);
  const { loading, error, data } = useQuery(FETCH_BOM, { variables: { ids } });

  if (loading) return <InlineSpinner text={null} size={21} />;
  if (error) return <Errors error={error} />;

  let notFoundChildProduct = false;

  const bomQty = parseInt(itemsPerSet, 10);
  const orderQty = parseInt(qty, 10);

  const components = bom.map((i) => {
    const childProduct = data.products.results.find(
      (p) => p.id === i.product.id,
    );
    if (!childProduct) {
      notFoundChildProduct = true;
      return { qty: 0, prices: [] };
    }
    return {
      qty: parseInt(i.qty, 10),
      prices: childProduct.activePrices.filter(
        (price) =>
          !price.archivedAt &&
          (!price.company ||
            price.company === "UNSET" ||
            price.company === company),
      ),
    };
  });

  if (notFoundChildProduct) return null;

  if (bomQty <= 0) return "Qty / Set must be greater than 0";
  if (orderQty < bomQty)
    return `Product default qty must be at least ${bomQty}`;

  const { costPerUnit } = computeCost(
    orderQty,
    bomQty,
    components,
    usdExchangeRates,
    currency,
  );
  const value = Number.isFinite(costPerUnit) ? costPerUnit : 0;

  return `${CURRENCY_DICT[currency].symbol} ${value.toFixed(3)}`;
};

export default CostPreview;
